<otel-instrumentation></otel-instrumentation>
<router-outlet></router-outlet>
